export default __webpack_public_path__ + "static/media/vincent.64c62b8c.png";